(function (window) {
    "use strict";
    function defineCurrencyHelper() {
        var currencyHelper = {};
        currencyHelper.numberToCurrency = function(value, currencySymbol){
            var number = Number(value);
            if(number){
                var currency = currencySymbol || "R";
                return currency + number.toFixed(2);
            }
            return "R0.00";
        };
        currencyHelper.roundToTwoDecimalPlaces = function(value){
            var number = Number(value);
            if(number){
                return Number(number.toFixed(2));
            }
            return 0.00;
        };
        return currencyHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (currencyHelper) === "undefined") {
        window.currencyHelper = defineCurrencyHelper();
    } else {
        console.log("currencyHelper already defined.");
    }
})(window);